import { useRuntimeConfig } from "#app"
import { useUrlSearchParams } from "@vueuse/core"

export const useEnvVar = (env_var: string) => {
  const config = useRuntimeConfig()
  const params = useUrlSearchParams("history")

  const canOverride =
    config.public.VITE_STAGE === "develop" ||
    config.public.VITE_STAGE === "uat" ||
    config.public.VITE_STAGE === "local"

  if (canOverride) {
    const keys = Object.keys(params)
    if (keys.includes(env_var)) {
      return params[env_var]
    }
  }

  return config.public[env_var]
}
